<div mat-dialog-title>
  <span>Attachments - {{ data.targetConditionName }}</span>
</div>

<mat-dialog-content>
  <!-- Loading indicator -->
  @if (isLoading() || isUploading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- Toolbar -->
  <div class="toolbar">
    <div class="toolbar-left">
      <button mat-icon-button (click)="navigateUp()" [disabled]="!currentPath()" matTooltip="Go up">
        <fa-icon [icon]="faArrowUp"></fa-icon>
      </button>
      <button mat-icon-button (click)="navigateToPath('')" matTooltip="Go to root">
        <fa-icon [icon]="faHome"></fa-icon>
      </button>

      <div class="breadcrumb-container">
        @for (crumb of breadcrumbs(); track crumb.path; let last = $last) {
          @if (!last) {
            <span class="breadcrumb-item clickable" (click)="onBreadcrumbClick(crumb)">{{ crumb.text }}</span>
            <span class="breadcrumb-separator">/</span>
          } @else {
            <span class="breadcrumb-item current">{{ crumb.text }}</span>
          }
        }
      </div>
    </div>

    <div class="toolbar-right">
      <button mat-icon-button (click)="showNewFolderDialog()" matTooltip="New folder" [disabled]="isLoading()">
        <fa-icon [icon]="faFolderPlus"></fa-icon>
      </button>

      <input
        type="file"
        #fileInput
        multiple
        (change)="onFileSelected($event)"
        style="display: none"
      />
      <button mat-icon-button (click)="fileInput.click()" matTooltip="Upload files" [disabled]="isLoading() || isUploading()">
        <fa-icon [icon]="faUpload"></fa-icon>
      </button>
    </div>
  </div>

  <!-- New folder input -->
  @if (showNewFolderInput()) {
    <div class="new-folder-input">
      <mat-form-field appearance="outline" class="folder-name-field">
        <mat-label>Folder name</mat-label>
        <input
          matInput
          [(ngModel)]="newFolderName"
          (keyup.enter)="createFolder()"
          (keyup.escape)="cancelNewFolder()"
          autofocus
        />
      </mat-form-field>
      <button mat-flat-button color="primary" (click)="createFolder()" [disabled]="!newFolderName.trim()">
        Create
      </button>
      <button mat-button (click)="cancelNewFolder()">
        Cancel
      </button>
    </div>
  }

  <!-- File/Folder list -->
  <div class="file-list">
    @if (currentItems().length === 0 && !isLoading()) {
      <div class="empty-state">
        <p>This folder is empty</p>
        <p class="empty-hint">Upload files or create a new folder to get started</p>
      </div>
    }

    @for (item of currentItems(); track item.name) {
      <div
        class="file-item"
        [class.selected]="isSelected(item)"
        [class.folder]="item.type === AttachmentType.Folder"
        (click)="onItemClick(item)"
        (dblclick)="onItemDoubleClick(item)"
      >
        <div class="file-icon" [ngClass]="getItemIconClass(item)">
          <fa-icon [icon]="getItemIcon(item)" size="xl"></fa-icon>
        </div>
        <div class="file-name">{{ item.name }}</div>
        <div class="file-actions">
          @if (item.type !== AttachmentType.Folder) {
            <button
              mat-icon-button
              (click)="downloadFile(item); $event.stopPropagation()"
              matTooltip="Download"
              class="download-btn"
            >
              <fa-icon [icon]="faDownload"></fa-icon>
            </button>
          }
          <button
            mat-icon-button
            (click)="deleteItem(item); $event.stopPropagation()"
            matTooltip="Delete"
            class="delete-btn"
          >
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </div>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
